import { render, staticRenderFns } from "./GRadioButtonsFormInput.vue?vue&type=template&id=6bad9e8b&scoped=true&"
import script from "./GRadioButtonsFormInput.vue?vue&type=script&lang=ts&"
export * from "./GRadioButtonsFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./GRadioButtonsFormInput.vue?vue&type=style&index=0&id=6bad9e8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad9e8b",
  null
  
)

export default component.exports